import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32b35967"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_use_svg = _resolveComponent("use-svg")!
  const _component_text_formatter = _resolveComponent("text-formatter")!
  const _component_base_card = _resolveComponent("base-card")!
  const _component_vue_final_modal = _resolveComponent("vue-final-modal")!

  return (_openBlock(), _createBlock(_component_vue_final_modal, {
    "overlay-style": { backgroundColor: 'var(--color-secondary-lighter-35)' },
    classes: "modal-container",
    "content-class": "modal-content"
  }, {
    default: _withCtx(({ close }) => [
      _createElementVNode("button", {
        onClick: close,
        class: "close"
      }, [
        _createVNode(_component_use_svg, { svg: "close" })
      ], 8, _hoisted_1),
      _createVNode(_component_base_card, { class: "modal__content" }, {
        default: _withCtx(() => [
          _createVNode(_component_text_formatter, {
            content: _ctx.translate('overview.beforeFirstVisitContent')
          }, null, 8, ["content"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["overlay-style"]))
}